import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { ChaingeChain, ChaingeToken } from 'types/baseType';

interface Props {
  fromChain: ChaingeChain
  toChain: ChaingeChain
  fromToken: ChaingeToken
  toToken: ChaingeToken
  fromAddress: string
  toAddress: string
  fromAmount: string
  toAmount: string
  toAmountUsdt: string
  isAnotherToAddress: boolean
  aggregator: string
  routeSummary: string
  miniToAmount: string
  fromTokenUsdt: string

  balanceEvm: string
  gas: string
  slippage: number

  balanceEnough: boolean
  isMinUsdt: boolean

  openChainWin: boolean,
  openAssetWin: boolean,
}

export const coreInfoSlice = createSlice({
  name: 'app',
  initialState: {
    slippage: 0,
    gas: '0',
    toAmount: '0.00',
    toAmountUsdt: '0.00',
    toAddress: '',

    balanceEnough: true,
    isMinUsdt: false,

    openChainWin: false,
    openAssetWin: false,
  } as Props,
  reducers: {
    setFromChain: (state, { payload } : PayloadAction<ChaingeChain>) => {
      state.fromChain = payload
    },
    setToChain: (state, { payload } : PayloadAction<ChaingeChain>) => {
      state.toChain = payload
    },

    setFromToken: (state, { payload } : PayloadAction<ChaingeToken>) => {
      state.fromToken = payload
    },
    setToToken: (state, { payload } : PayloadAction<ChaingeToken>) => {
      state.toToken = payload
    },

    setFromAddress:  (state, { payload } : PayloadAction<string>) => {
      state.fromAddress = payload
    },

    setToAddress:  (state, { payload } : PayloadAction<string>) => {
      state.toAddress = payload
    },

    setFromAmount:  (state, { payload } : PayloadAction<string>) => {
      state.fromAmount = payload
    },
    setToAmount:  (state, { payload } : PayloadAction<string>) => {
      state.toAmount = payload
    },
    setToAmountUsdt: (state, { payload } : PayloadAction<string>) => {
      state.toAmountUsdt = payload
    },

    setBalanceEvm: (state, { payload } : PayloadAction<string>) => {
      state.balanceEvm = payload
    },

    setGas: (state, { payload } : PayloadAction<string>) => {
      state.gas = payload
    },
    setSlippage: (state, { payload } : PayloadAction<number>) => {
      state.slippage = payload
    },

    setIsAnotherToAddress: (state, { payload } : PayloadAction<boolean>) => {
      state.isAnotherToAddress = payload
    },

    setBalanceEnough: (state, { payload } : PayloadAction<boolean>) => {
      state.balanceEnough = payload
    },
    setIsMinUsdt: (state, { payload } : PayloadAction<boolean>) => {
      state.isMinUsdt = payload
    },
    setAggregator: (state, { payload } : PayloadAction<string>) => {
      state.aggregator = payload
    },
    setRouteSummary: (state, { payload } : PayloadAction<string>) => {
      state.routeSummary = payload
    },
    setMiniToAmount: (state, { payload } : PayloadAction<string>) => {
      state.miniToAmount = payload
    },
    setFromTokenUsdt: (state, { payload } : PayloadAction<string>) => {
      state.fromTokenUsdt = payload
    },
    setResetInfo: (state) => {
      state.toAmount = ''
      state.toAddress = ''
      state.slippage = 0
      state.gas = '0.00'
      state.miniToAmount = '0.00'
      state.aggregator = ''
      state.toAmountUsdt = '0.00'
      state.fromAmount = ''
      state.routeSummary = ''
    },
  }
})

// Action creators are generated for each case reducer function
export const { setFromChain, setToChain, setFromToken, setToToken, setFromAddress, setToAddress, setFromAmount, setToAmount, setToAmountUsdt, setBalanceEvm, setGas, setSlippage, setIsAnotherToAddress, setBalanceEnough, setIsMinUsdt, setAggregator, setRouteSummary, setMiniToAmount, setResetInfo, setFromTokenUsdt } = coreInfoSlice.actions

export default coreInfoSlice.reducer